var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"errorModal",attrs:{"title":"Error","ok-only":"","header-bg-variant":"danger","header-text-variant":"light","ok-variant":"secondary"},on:{"ok":_vm.action}},[_c('p',[_vm._v(_vm._s(_vm.message))])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-478189d8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/modals/ErrorComponent.vue
// module id = CTol
// module chunks = 0